module.exports = __webpack_public_path__ + "static/media/logo.8213a9f0.svg";